




























import { Component, Vue } from 'vue-property-decorator';

import { PrintType, PrintContext } from './Scripts/PrintContext';
import { IProgram, ICourse, SearchType } from './Scripts/ISearchService';
import { QueryString } from './Scripts/QueryString';

import QueryPanel from './components/QueryPanel.vue';
import FavoritesCount from './components/FavoritesCount.vue';
import PrintPanel from './components/PrintPanel.vue';
import GridView from './components/GridView.vue';

import { IDisclaimerInfo } from './Scripts/Discaimer';
import DisclaimerPanel from './components/DisclaimerPanel.vue';
import DisclaimerSource from './Scripts/DisclaimerSource';

import AppConfig from './Scripts/AppConfig';

import ActionTracker, { OpenSearchPrintEvent } from './Scripts/AnalyticsEvents';

@Component({
	components: {
		QueryPanel, FavoritesCount, PrintPanel, GridView, DisclaimerPanel
	}
})
export default class App extends Vue {
	get printContext (): PrintContext {
		return this.$store.state.printContext;
	}

	get items (): IProgram[] | ICourse[] {
		return this.$store.state.result ? this.$store.state.result.items : [];
	}

	get searchType (): SearchType {
		return this.$store.state.result ? this.$store.state.result.searchType : SearchType.Program;
	}

	private print () {
		const pathWithoutPrint = this.$route.fullPath;

		const query = new QueryString(this.$router);

		query.set('print', 'true').navigate();

		const items = this.$store.state.result.items;
		const searchType = this.$store.state.result.searchType;

		const print = new PrintContext(PrintType.Results, items, searchType, pathWithoutPrint);

		this.$store.commit('setPrintContext', print);

		ActionTracker.track(new OpenSearchPrintEvent());
	}

	private closePrint () {
		this.$store.commit('setPrintContext', null);
		this.$router.go(-1);
	}

	private grid () {
		this.$bvModal.show('grid-modal');
	}

	get disclaimerInfo (): IDisclaimerInfo {
		const body = DisclaimerSource.getHtml();

		return {
			enabled: AppConfig.disclaimerEnabled,
			title: AppConfig.disclaimerTitle,
			body: body,
			acknowledgement: AppConfig.disclaimerAcknowledgement
		};
	}
}
